import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { auth, sendPasswordReset } from "./UsersConfig/Authfirebase";
import "./Users.css";

function Reset() {
  const [email, setEmail] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (user) navigate("/dashboard");
  }, [user, loading]);

  const ResetPass=()=>{
    if (!email) {alert("Please enter Email"); return;}
   sendPasswordReset(email);
  }
  return (
    
      <div className="containerUser">
      <img src={process.env.PUBLIC_URL+"/Logo.png"}  alt="Empresa"/>
        <h3>Reiniciar contraseña</h3>

        <input
          type="text"
          className="bsInput"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="E-mail Address"
        />
        
        <button className="bsButton" onClick={ResetPass}>
          Reiniciar contraseña
        </button>

 
      </div>
    
  );
}

export default Reset;